"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("./util/index");

var restpaginator_1 = require("./restpaginator");

var synclistdescriptor_1 = require("./synclistdescriptor");
/**
 * Provides async pagination interface for sync list
 *
 * @property {Network} network Network transport
 * @property {string} syncListUrl Url to the sync list endpoint
 */


var SyncList = function () {
  /**
   * @param {SyncListServices} services - services needed for SyncList service
   * @private
   */
  function SyncList(services) {
    (0, _classCallCheck3["default"])(this, SyncList);
    this.services = services;
  }

  (0, _createClass3["default"])(SyncList, [{
    key: "getPage",
    value: function () {
      var _ref = (0, _asyncToGenerator3["default"])(
      /*#__PURE__*/
      _regenerator2["default"].mark(function _callee(args) {
        var _this = this;

        var links, url, response;
        return _regenerator2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                args = args || {};
                _context.next = 3;
                return this.services.session.getSessionLinks();

              case 3:
                links = _context.sent;
                url = new index_1.UriBuilder(links.syncListUrl).arg('PageToken', args.pageToken).build();
                _context.next = 7;
                return this.services.network.get(url);

              case 7:
                response = _context.sent;
                return _context.abrupt("return", new restpaginator_1.RestPaginator(response.body.channels.map(function (x) {
                  return new synclistdescriptor_1.SyncListDescriptor(x);
                }), function (pageToken) {
                  return _this.getPage({
                    pageToken: pageToken
                  });
                }, response.body.meta.previous_token, response.body.meta.next_token));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPage(_x) {
        return _ref.apply(this, arguments);
      }

      return getPage;
    }()
  }]);
  return SyncList;
}();

exports.SyncList = SyncList;